import { Button } from "antd";
import styled, { css } from "styled-components";

export const StyledFloatingActionButton = styled(Button)<{
    $top?: number;
    $right?: number;
    $bottom?: number;
    $left?: number;
    $position: "absolute" | "fixed";
    $size: number;
    $zIndex: number;
    $bgColor?: "success" | "error";
    $iconSize: number;
}>`
    padding: 0;
    position: ${({ $position }) => $position};
    z-index: ${({ $zIndex }) => $zIndex};

    ${({ $top }) =>
        $top !== undefined &&
        css`
            top: ${$top}px;
        `}
    ${({ $right }) =>
        $right !== undefined &&
        css`
            right: ${$right}px;
        `}
    ${({ $bottom }) =>
        $bottom !== undefined &&
        css`
            bottom: ${$bottom}px;
        `}
    ${({ $left }) =>
        $left !== undefined &&
        css`
            left: ${$left}px;
        `}

    width: ${({ $size }) => `${$size}px`} !important;
    height: ${({ $size }) => `${$size}px`};

    background: ${({ $bgColor, theme }) => {
        switch ($bgColor) {
            case "success":
                return theme.colors.green;
            case "error":
                return theme.dangerTypographyColor;
            default:
                return "inherit";
        }
    }};

    &:hover {
        background: ${({ $bgColor, theme }) => {
            switch ($bgColor) {
                case "success":
                    return theme.colors.green;
                case "error":
                    return theme.dangerTypographyColor;
                default:
                    return "inherit";
            }
        }} !important;
    }

    svg {
        font-size: ${({ $iconSize }) => `${$iconSize}px`};
        color: ${({ theme }) => theme.colors.white};
    }
`;
